import * as React from 'react';
import CallbackHelpers from '../helpers/CallbackHelpers';
import {Func} from '../types/Func';
import {BusinessUnitFilter} from '../types/BusinessUnitFilter';
import {BusinessUnitEntry} from '../../reports/types/BusinessUnitEntry';

export interface BusinessUnitCacheProps {
  getUnits: (filter: BusinessUnitFilter) => BusinessUnitEntry[];
  clearBusinessUnitCache: Func;
  isBusinessUnitCacheProcessing: boolean;
}

export const BusinessUnitCache = React.createContext<BusinessUnitCacheProps>({
  getUnits: CallbackHelpers.ThrowNotImplemented,
  clearBusinessUnitCache: CallbackHelpers.NoOp,
  isBusinessUnitCacheProcessing: false
});
